<header id="header-wrap">
  <!-- Navbar Start -->
  <app-navbar></app-navbar>
  <!-- Navbar End -->

  <!-- Hero Area Start -->

  <div id="hero-area" class="hero-area-bg">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
          <div class="contents">
            <h2 class="head-title">ANGSAKU IS NOW<br>AVAILABLE IN</h2>
            <div class="header-button mb-4">

              <img *ngIf="deviceOS == 'ios' || deviceOS == 'windows'" (click)="downloadNow()" class="mr-1" src="assets/img/app_store.png">

              <a *ngIf="deviceOS == 'android' || deviceOS == 'windows'" (click)="downloadNow()">
                <img class="ml-1 mr-1" src="assets/img/play_store.png">
              </a>

              <!-- <a *ngIf="deviceOS == 'windows'" (click)="downloadNow()">
                <img class="mr-1" src="assets/img/windows_download.png">
              </a> -->

              <a *ngIf="deviceOS == 'android'" (click)="downloadOfficial()">
                <img class="ml-1" src="assets/img/official_btn.png">
              </a>


              <!-- <a class="official_btn" (click)="downloadNow()">
                <div class="d-flex flex-row">
                  <span class="download-icon material-icons">download</span>
                  <span>Offical Download</span>
                </div>
              </a> -->


              <!-- <input type="file" accept="image/*"  (change)="checkimgSrc($event.target.files)">
                <img [src]="imgSrc" width=200 height=200 /> -->
              <!-- <a href="#" class="btn btn-common">Download Now</a>
              <a href="#" class="btn btn-border video-popup">Learn More</a> -->
            </div>
            <p>Keep your property safe with Angsaku App, manage your property with your convenience, communicate easily
              with your Neighbourhood and Management Office.</p>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
          <div class="intro-img">
            <img class="img-fluid" src="assets/img/intro-mobile.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Hero Area End -->

</header>
<!-- Header Area wrapper End -->

<!-- Services Section Start -->
<a href="geo:40.765819,-73.975866">Open Map</a>
<section id="services" class="section-padding">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Why Angsaku ?</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row">
      <!-- Services item -->
      <div class="col-md-6 col-lg-4 col-xs-12">
        <div class="services-item wow fadeInRight" data-wow-delay="0.9s">
          <div class="icon">
            <i class="material-icons">
              add_moderator
            </i>

          </div>
          <div class="services-content">
            <h3><a href="#">Resident</a></h3>
            <p>Get your tailor-made mobile app with all features that manage security, communication and convenience of
              your neighborhoods. Enable seamless access of your property and your personal data is well protected by
              military-grade encryption.</p>
          </div>
        </div>
      </div>
      <!-- Services item -->
      <div class="col-md-6 col-lg-4 col-xs-12">
        <div class="services-item wow fadeInRight" data-wow-delay="1.2s">
          <div class="icon">
            <i class="material-icons">
              memory
            </i>
          </div>
          <div class="services-content">
            <h3><a href="#">Admin & Manager</a></h3>
            <p>Transform into digitalization which leverages neighborhoods activities/behaviors to improve business
              competitiveness. Manage your entire business through a single interface- Monitoring, Payment, Interaction
              & Run Marketing Campaigns. </p>
          </div>
        </div>
      </div>
      <!-- Services item -->
      <div class="col-md-6 col-lg-4 col-xs-12">
        <div class="services-item wow fadeInRight" data-wow-delay="1.5s">
          <div class="icon">

            <i class="material-icons">
              insights
            </i>
          </div>
          <div class="services-content">
            <h3><a href="#">Service Provider</a></h3>
            <p>Enhance your productivity with optimization features that powered by latest technologies. Give your team
              the most powerful tool to simplify the operations, and an easy-to-use platform.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Services Section End -->

<!-- About Section start -->
<div class="about-area section-padding bg-gray">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12 info">
        <div class="about-wrapper wow fadeInLeft" data-wow-delay="0.3s">
          <div>
            <div class="site-heading">
              <!-- <p class="mb-3">Manage Statistics</p> -->
              <h2 class="section-title">Easy and convenient</h2>
            </div>
            <div class="content">
              <p>
                An user friendly interface that allows you to manage the property like an expert, you are able to manage
                the multiple properties in the APP without a security concern.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12 wow fadeInRight" data-wow-delay="0.3s">
        <img class="img-fluid" src="assets/img/about/easytouse.png" alt="">
      </div>
    </div>
  </div>
</div>
<!-- About Section End -->

<!-- About Section start -->
<div class="about-area section-padding">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12 wow fadeInRight" data-wow-delay="0.3s">
        <img class="img-fluid" src="assets/img/feature/security_guard.png" alt="">
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12 info">
        <div class="about-wrapper wow fadeInRight" data-wow-delay="0.3s">
          <div>
            <div class="site-heading">
              <!-- <p class="mb-3">Manage Statistics</p> -->
              <h2 class="section-title">Secure optimization</h2>
            </div>
            <div class="content">
              <p>
                All the data is well encrypted and personal data leak protected with PDPA & EU’s GDPR compliance.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<!-- About Section End -->

<!-- About Section start -->
<div class="about-area section-padding bg-gray">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12 info">
        <div class="about-wrapper wow fadeInLeft" data-wow-delay="0.3s">
          <div>
            <div class="site-heading">
              <!-- <p class="mb-3">Manage Statistics</p> -->
              <h2 class="section-title">Digitalization</h2>
            </div>
            <div class="content">
              <p>
                Angsaku platform helps property manager/JMB/MC/sub-MC/RA/MCST to transform into digitalization which
                leverages
                neighborhoods activities/communications/behaviors to improve business competitiveness.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12 wow fadeInRight" data-wow-delay="0.3s">
        <img class="img-fluid" src="assets/img/about/digitalization.png" alt="">
      </div>
    </div>
  </div>
</div>
<!-- About Section End -->

<!-- Features Section Start -->
<section id="features" class="section-padding" *ngIf="devicePc">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Powerful Features of Angsaku</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-right">
          <div class="box-item wow fadeInDown" data-wow-delay="0.3s" (click)="openfeaturePage('panic_alert')">
            <span class="icon">
              <i class="material-icons" style="color: #218C8D;">
                warning
              </i>
            </span>
            <div class="text">
              <h4>Panic alert</h4>
              <p>Seek for assistance immediately</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-left">
          <div class="box-item wow fadeInLeft" data-wow-delay="0.3s" style="right: 160px;margin-top: -4px;"
            (click)="openfeaturePage('mini_apps')">
            <span class="icon">
              <i class="material-icons" style="color: #6CCECB;">
                apps
              </i>
            </span>
            <div class="text">
              <h4>Mini Apps</h4>
              <p>Incredible services beyond your expectation</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-right">
          <div class="box-item wow fadeInRight" data-wow-delay="0.3s" style="left: 160px;margin-top: -4px;"
            (click)="openfeaturePage('committee')">
            <span class="icon">
              <i class="material-icons" style="color: #b9a91c;">
                people
              </i>
            </span>
            <div class="text">
              <h4>Committee</h4>
              <p>Know the committee and build pleasant/harmony environment</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-left">
          <div class="box-item wow fadeInLeft" data-wow-delay="0.6s" style="right: 100px;"
            (click)="openfeaturePage('intercom')">
            <span class="icon">
              <i class="material-icons" style="color: #EF7126;">
                phone_android
              </i>
            </span>
            <div class="text">
              <h4>Video intercom</h4>
              <p>Communicate securely with security guards / management officers</p>
            </div>
          </div>
          <div class="box-item wow fadeInLeft" data-wow-delay="0.9s" style="right: 160px;"
            (click)="openfeaturePage('facility_booking')">
            <span class="icon">
              <i class="material-icons" style="color: #8EDC9D;">
                apartment
              </i>
            </span>

            <div class="text">
              <h4>Facilities Booking</h4>
              <p>Reserve facilities without physically present</p>
            </div>
          </div>

          <div class="box-item wow fadeInLeft" data-wow-delay="0.9s" style="right: 220px;"
            (click)="openfeaturePage('family_sharing')">
            <span class="icon">
              <i class="material-icons" style="color: #486ba4;">
                family_restroom
              </i>
            </span>

            <div class="text">
              <h4>Family sharing</h4>
              <p>Your family member possesses privileges just like you</p>
            </div>
          </div>
          <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" style="right: 160px;"
            (click)="openfeaturePage('discussion')">
            <span class="icon">
              <i class="material-icons" style="color: #73000d;">
                question_answer
              </i>
            </span>
            <div class="text">
              <h4>Discussion</h4>
              <p>Enable strong community spirit through chat discussion</p>
            </div>
          </div>
          <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" style="right: 100px;"
            (click)="openfeaturePage('visitor_management')">
            <span class="icon">
              <i class="material-icons" style="color: #473E3F;">
                manage_accounts
              </i>
            </span>
            <div class="text">
              <h4>Visitor Management</h4>
              <p>Eliminating hectic visitor paperwork</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="show-box wow fadeInUp" data-wow-delay="0.3s">
          <img src="assets/img/feature/intro-mobile.png" alt="">
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-right">
          <div class="box-item wow fadeInRight" data-wow-delay="0.3s" style="left: 100px;"
            (click)="openfeaturePage('feedback')">
            <span class="icon">
              <i class="material-icons" style="color: #F2C249;">
                feedback
              </i>
            </span>
            <div class="text">
              <h4>Feedback</h4>
              <p>Post feedback / complaint with relevant photos</p>
            </div>
          </div>
          <div class="box-item wow fadeInRight" data-wow-delay="0.6s" style="left: 160px;"
            (click)="openfeaturePage('e_form')">
            <span class="icon">
              <i class="material-icons" style="color: #E6772E;">
                summarize
              </i>
            </span>
            <div class="text">
              <h4>E-Form</h4>
              <p>Fill the form digitally for surveys or event registration</p>
            </div>
          </div>
          <div class="box-item wow fadeInRight" data-wow-delay="0.6s" style="left: 220px;"
            (click)="openfeaturePage('e_doc')">
            <span class="icon">
              <i class="material-icons" style="color: #892ee6;">
                feed
              </i>
            </span>
            <div class="text">
              <h4>E-documents</h4>
              <p>Important documents at your fingertips</p>
            </div>
          </div>
          <div class="box-item wow fadeInRight" data-wow-delay="0.6s" style="left: 160px;"
            (click)="openfeaturePage('e_form')">
            <span class="icon">
              <i class="material-icons" style="color: #2b91bd;">
                support
              </i>
            </span>
            <div class="text">
              <h4>Support</h4>
              <p>Communicate with us to solve your issue</p>
            </div>
          </div>
          <div class="box-item wow fadeInRight" data-wow-delay="0.9s" style="left: 100px;"
            (click)="openfeaturePage('highlights')">
            <span class="icon">
              <i class="material-icons" style="color: #4DB3B3;">
                campaign
              </i>
            </span>
            <div class="text">
              <h4>Highlights</h4>
              <p>Post highlights with notifications</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-left">
          <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" style="right: 160px;"
            (click)="openfeaturePage('weather')">
            <span class="icon">
              <i class="material-icons" style="color: #3D4C53;">
                nights_stay
              </i>
            </span>
            <div class="text">
              <h4>Weather</h4>
              <p>Avoid uncertainties that may cause by climate changes</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-right">
          <div class="box-item wow fadeInRight" data-wow-delay="1.2s" style="left: 160px;"
            (click)="openfeaturePage('one_to_many')">
            <span class="icon">
              <i class="material-icons" style="color: #E64A45;">
                manage_accounts
              </i>
            </span>
            <div class="text">
              <h4>One-to-Many</h4>
              <p>Just one app to manage multiple units</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row justify-content-center">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="content-right">
          <div class="box-item wow fadeInUp" data-wow-delay="1.2s" style="margin-top: -4px;"
            (click)="openfeaturePage('e_billing')">
            <span class="icon">
              <i class="material-icons" style="color: #787A40;">
                receipt_long
              </i>
            </span>
            <div class="text">
              <h4>E-billings</h4>
              <p>Secure In-APP Payment for bills</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Features Section End -->


<!-- Features Section Start (mobile) -->
<section id="features" class="section-padding" *ngIf="!devicePc">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Powerful Features of Angsaku</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
      <div class="show-box wow fadeInUp" data-wow-delay="0.3s">
        <img src="assets/img/feature/intro-mobile.png" alt="">
      </div>
    </div>
    <div id="testimonials" class="owl-carousel wow fadeInUp" data-wow-delay="1.2s">
      <div class="item">
        <div class="testimonial-item">
          <div class="content-right">
            <div class="box-item wow fadeInDown" data-wow-delay="0.3s" (click)="openfeaturePage('panic_alert')">
              <span class="icon">
                <i class="material-icons" style="color: #218C8D;">
                  warning
                </i>
              </span>
              <div class="text">
                <h4>Panic alert</h4>
                <p>Seek for assistance immediately</p>
              </div>
            </div>
            <div class="box-item wow fadeInLeft" data-wow-delay="0.3s" (click)="openfeaturePage('mini_apps')">
              <span class="icon">
                <i class="material-icons" style="color: #6CCECB;">
                  apps
                </i>
              </span>
              <div class="text">
                <h4>Mini Apps</h4>
                <p>Incredible services beyond your expectation</p>
              </div>
            </div>
            <div class="box-item wow fadeInRight" data-wow-delay="0.3s" (click)="openfeaturePage('committee')">
              <span class="icon">
                <i class="material-icons" style="color: #b9a91c;">
                  people
                </i>
              </span>
              <div class="text">
                <h4>Committee</h4>
                <p>Know the committee and build pleasant/harmony environment</p>
              </div>
            </div>
            <div class="box-item wow fadeInLeft" data-wow-delay="0.6s" (click)="openfeaturePage('intercom')">
              <span class="icon">
                <i class="material-icons" style="color: #EF7126;">
                  phone_android
                </i>
              </span>
              <div class="text">
                <h4>Video intercom</h4>
                <p>Communicate securely with security guards / management officers</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="testimonial-item">
          <div class="content-right">
            <div class="box-item wow fadeInLeft" data-wow-delay="0.9s" (click)="openfeaturePage('facility_booking')">
              <span class="icon">
                <i class="material-icons" style="color: #8EDC9D;">
                  apartment
                </i>
              </span>

              <div class="text">
                <h4>Facilities Booking</h4>
                <p>Reserve facilities without physically present</p>
              </div>
            </div>
            <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" (click)="openfeaturePage('family_sharing')">
              <span class="icon">
                <i class="material-icons" style="color: #486ba4;">
                  family_restroom
                </i>
              </span>
              <div class="text">
                <h4>Family sharing</h4>
                <p>Your family member possesses privileges just like you</p>
              </div>
            </div>
            <div class="box-item wow fadeInRight" data-wow-delay="0.3s" (click)="openfeaturePage('discussion')">
              <span class="icon">
                <i class="material-icons" style="color: #73000d;">
                  question_answer
                </i>
              </span>
              <div class="text">
                <h4>Discussion</h4>
                <p>Enable strong community spirit through chat discussion</p>
              </div>
            </div>
            <div class="box-item wow fadeInRight" data-wow-delay="0.6s" (click)="openfeaturePage('visitor_management')">
              <span class="icon">
                <i class="material-icons" style="color: #473E3F;">
                  manage_accounts
                </i>
              </span>
              <div class="text">
                <h4>Visitor Management</h4>
                <p>Eliminating hectic visitor paperwork</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="item">
        <div class="testimonial-item">
          <div class="content-right">
            <div class="box-item wow fadeInRight" data-wow-delay="0.9s" (click)="openfeaturePage('feedback')">
              <span class="icon">
                <i class="material-icons" style="color: #F2C249;">
                  feedback
                </i>
              </span>
              <div class="text">
                <h4>Feedback</h4>
                <p>Post feedback / complaint with relevant photos</p>
              </div>
            </div>
            <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" (click)="openfeaturePage('e_form')">
              <span class="icon">
                <i class="material-icons" style="color: #E6772E;">
                  summarize
                </i>
              </span>
              <div class="text">
                <h4>E-Form</h4>
                <p>Fill the form digitally for surveys or event registration</p>
              </div>
            </div>
            <div class="box-item wow fadeInRight" data-wow-delay="1.2s" (click)="openfeaturePage('e_doc')">
              <span class="icon">
                <i class="material-icons" style="color: #892ee6;">
                  feed
                </i>
              </span>
              <div class="text">
                <h4>E-documents</h4>
                <p>Important documents at your fingertips</p>
              </div>
            </div>
            <!-- <div class="box-item wow fadeInUp" data-wow-delay="1.2s" (click)="openfeaturePage('e_doc')">
              <span class="icon">
                <i class="material-icons" style="color: #2b91bd;">
                  feed
                </i>
              </span>
              <div class="text">
                <h4>Unknown</h4>
                <p>new feature</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="item">
        <div class="testimonial-item">
          <div class="content-right">
            <div class="box-item wow fadeInRight" data-wow-delay="0.9s" (click)="openfeaturePage('weather')">
              <span class="icon">
                <i class="material-icons" style="color: #3D4C53;">
                  nights_stay
                </i>
              </span>
              <div class="text">
                <h4>Weather</h4>
                <p>Avoid uncertainties that may cause by climate changes</p>
              </div>
            </div>
            <div class="box-item wow fadeInLeft" data-wow-delay="1.2s" (click)="openfeaturePage('one_to_many')">
              <span class="icon">
                <i class="material-icons" style="color: #E64A45;">
                  manage_accounts
                </i>
              </span>
              <div class="text">
                <h4>One-to-Many</h4>
                <p>Just one app to manage multiple units</p>
              </div>
            </div>
            <div class="box-item wow fadeInRight" data-wow-delay="1.2s" (click)="openfeaturePage('e_billing')">
              <span class="icon">
                <i class="material-icons" style="color: #787A40;">
                  receipt_long
                </i>
              </span>
              <div class="text">
                <h4>E-billings</h4>
                <p>Secure In-APP Payment for bills</p>
              </div>
            </div>
            <div class="box-item wow fadeInUp" data-wow-delay="1.2s" (click)="openfeaturePage('highlights')">
              <span class="icon">
                <i class="material-icons" style="color: #4DB3B3;">
                  campaign
                </i>
              </span>
              <div class="text">
                <h4>Highlights</h4>
                <p>Post highlights with notifications</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>
<!-- Features Section End (mobile)-->

<!-- Team Section Start -->
<!-- <section id="team" class="section-padding bg-gray">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Meet our team</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-xs-12">
        Team Item Starts
        <div class="team-item wow fadeInRight" data-wow-delay="0.2s">
          <div class="team-img">
            <img class="img-fluid" src="assets/img/team/team-01.png" alt="">
          </div>
          <div class="contetn">
            <div class="info-text">
              <h3><a href="#">David Smith</a></h3>
              <p>Front-end Developer</p>
            </div>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
            <ul class="social-icons">
              <li><a href="#"><i class="lni-facebook-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-twitter-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-instagram-filled" aria-hidden="true"></i></a></li>
            </ul>
          </div>
        </div>
        Team Item Ends
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        Team Item Starts
        <div class="team-item wow fadeInRight" data-wow-delay="0.4s">
          <div class="team-img">
            <img class="img-fluid" src="assets/img/team/team-02.png" alt="">
          </div>
          <div class="contetn">
            <div class="info-text">
              <h3><a href="#">ERIC PETERSON</a></h3>
              <p>Product Designer</p>
            </div>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
            <ul class="social-icons">
              <li><a href="#"><i class="lni-facebook-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-twitter-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-instagram-filled" aria-hidden="true"></i></a></li>
            </ul>
          </div>
        </div>
        Team Item Ends
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        Team Item Starts
        <div class="team-item wow fadeInRight" data-wow-delay="0.6s">
          <div class="team-img">
            <img class="img-fluid" src="assets/img/team/team-03.png" alt="">
          </div>
          <div class="contetn">
            <div class="info-text">
              <h3><a href="#">DURWIN BABB</a></h3>
              <p>Lead Designer</p>
            </div>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
            <ul class="social-icons">
              <li><a href="#"><i class="lni-facebook-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-twitter-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-instagram-filled" aria-hidden="true"></i></a></li>
            </ul>
          </div>
        </div>
        Team Item Ends
      </div>
      <div class="col-lg-6 col-md-12 col-xs-12">
        Team Item Starts
        <div class="team-item wow fadeInRight" data-wow-delay="0.8s">
          <div class="team-img">
            <img class="img-fluid" src="assets/img/team/team-04.png" alt="">
          </div>
          <div class="contetn">
            <div class="info-text">
              <h3><a href="#">MARIJN OTTE</a></h3>
              <p>Lead Designer</p>
            </div>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
            <ul class="social-icons">
              <li><a href="#"><i class="lni-facebook-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-twitter-filled" aria-hidden="true"></i></a></li>
              <li><a href="#"><i class="lni-instagram-filled" aria-hidden="true"></i></a></li>
            </ul>
          </div>
        </div>
        Team Item Ends
      </div>
    </div>
  </div>
</section> -->
<!-- Team Section End -->

<!-- Pricing section Start -->
<!-- <section id="pricing" class="section-padding">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Pricing</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="table wow fadeInLeft" data-wow-delay="1.2s">
          <div class="icon-box">
            <i class="lni-package"></i>
          </div>
          <div class="pricing-header">
            <p class="price-value">$10<span> /mo</span></p>
          </div>
          <div class="title">
            <h3>Pro</h3>
          </div>
          <ul class="description">
            <li>1 user</li>
            <li>10 GB storage</li>
            <li>Email support</li>
            <li>Lifetime updates</li>
          </ul>
          <button class="btn btn-common">Buy Now</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12 active">
        <div class="table wow fadeInUp" id="active-tb" data-wow-delay="1.2s">
          <div class="icon-box">
            <i class="lni-drop"></i>
          </div>
          <div class="pricing-header">
            <p class="price-value">$35<span> /mo</span></p>
          </div>
          <div class="title">
            <h3>Plus</h3>
          </div>
          <ul class="description">
            <li>10 user</li>
            <li>30 GB storage</li>
            <li>Priority email support</li>
            <li>Lifetime updates</li>
          </ul>
          <button class="btn btn-common">Buy Now</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-xs-12">
        <div class="table wow fadeInRight" data-wow-delay="1.2s">
          <div class="icon-box">
            <i class="lni-star"></i>
          </div>
          <div class="pricing-header">
            <p class="price-value">$150<span> /mo</span></p>
          </div>
          <div class="title">
            <h3>Premium</h3>
          </div>
          <ul class="description">
            <li>Unlimited users</li>
            <li>Unlimited storage</li>
            <li>24/7 support</li>
            <li>Lifetime updates</li>
          </ul>
          <button class="btn btn-common">Buy Now</button>
        </div>
      </div>
    </div>
  </div>
</section> -->
<!-- Pricing Table Section End -->


<!-- Section for Why ApaCheck -->
<section class="section-padding bg-gray" id="apaCheck" >
  <div class="container">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-xs-12 wow fadeInLeft d-flex align-items-center" data-wow-delay="0.3s">
        <div class="cta-text">
          <h4>Are you looking for something else?</h4>
          <br>
          <!-- <a href="#" class="btn btn-common">Go to ApaCheck</a> -->
          <button class="btn btn-common" type="button" (click)="naviTo()">Go to ApaCheck
          </button>
          <!-- <p>Praesent imperdiet, tellus et euismod euismod, risus lorem euismod erat, at finibus neque odio quis metus.
            Donec vulputate arcu quam. </p> -->
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-xs-12 text-right wow fadeInRight" data-wow-delay="0.3s">
        <div class="show-box wow fadeInUp" data-wow-delay="0.3s">
          <img class="app-check-image" src="assets/img/apacheck/image-go-to.png" alt="">
        </div>
        <!-- <br><a href="#" class="btn btn-common">Go to ApaCheck</a> -->
      </div>
    </div>
  </div>
</section>
<!-- Section for Why ApaCheck End -->

<!-- Call To Action Section Start -->
<!-- <section id="cta" class="section-padding">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-xs-12 wow fadeInLeft" data-wow-delay="0.3s">
        <div class="cta-text">
          <h4>Get 30 days free trial</h4>
          <p>Praesent imperdiet, tellus et euismod euismod, risus lorem euismod erat, at finibus neque odio quis metus.
            Donec vulputate arcu quam. </p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12 text-right wow fadeInRight" data-wow-delay="0.3s">
        <br><a href="#" class="btn btn-common">Register Now</a>
      </div>
    </div>
  </div>
</section> -->
<!-- Call To Action Section Start -->

<!-- Contact Section Start -->
<section id="contact" class="section-padding">
  <div class="container">
    <div class="section-header text-center">
      <h2 class="section-title wow fadeInDown" data-wow-delay="0.3s">Contact Us</h2>
      <div class="shape wow fadeInDown" data-wow-delay="0.3s"></div>
    </div>
    <div class="row contact-form-area wow fadeInUp" data-wow-delay="0.3s">
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="contact-block">
          <form [formGroup]="contactForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">

                  <input type="text" class="form-control" id="name" name="name" placeholder="Name" required formControlName="name"
                    data-error="Please enter your name">
                    <div class="d-flex flex-row">
                      <div class="d-flex flex-column" *ngIf="f.name.touched && f.name.invalid">
                          <small class="text-danger" *ngIf="f.name.errors.required">Name is required</small>
                      </div>
                      <!-- <div class="d-flex flex-column ml-auto">
                          <code class="text-muted">{{ name.value.length }}/150</code>
                      </div> -->
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input type="text" placeholder="Email" id="email" class="form-control" name="email" formControlName="email" required
                    data-error="Please enter your email">
                    <div class="d-flex flex-row">
                      <div class="d-flex flex-column" *ngIf="f.email.touched && f.email.invalid">
                        <small class="text-danger" *ngIf="f.email.errors.required">Email is required</small>
                        <small class="text-danger" *ngIf="f.email.errors.minlength">Minimum length must more than 6</small>
                        <small class="text-danger" *ngIf="!f.email.errors.minlength && f.email.errors.pattern">Incorrect email format (E.g. user@example.com)</small>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <input type="text" placeholder="Subject" id="msg_subject" class="form-control" formControlName="subject" required
                    data-error="Please enter your subject">
                    <div class="d-flex flex-column" *ngIf="f.subject.touched && f.subject.invalid">
                      <small class="text-danger" *ngIf="f.subject.errors.required">Subject is required</small>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <textarea class="form-control" id="message" placeholder="Your Message" rows="7" formControlName="message"
                    data-error="Write your message" required></textarea>
                    <div class="d-flex flex-column" *ngIf="f.message.touched && f.message.invalid">
                      <small class="text-danger" *ngIf="f.message.errors.required">Message is required</small>
                  </div>
                </div>
                <div class="form-group">
                  <re-captcha formControlName="recaptcha"
                  (resolved)="resolved($event)" [siteKey]="siteKey" (error)="errored($event)" errorMode="handled"></re-captcha>
                </div>
                <div class="submit-button text-left">
                  <button class="btn btn-common" id="form-submit" type="button" [disabled]="!contactForm.valid || loading" appDebounceClick (debounceClick)="onContactSubmit()">Send Message
                    <div class="spinner-border spinner-border-sm" *ngIf="loading">
                      <span class="sr-only">Loading...</span>
                  </div>
                  </button>
                  <div id="msgSubmit" class="h3 text-center hidden"></div>
                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="col-lg-5 col-md-12 col-xs-12">
        <svg class="contact-us" viewBox="0 0 416 416" fill="none" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <rect width="416" height="416" fill="url(#pattern0)" />
          <rect x="1" y="1" width="414" height="414" stroke="white" stroke-opacity="0.5" stroke-width="2" />
          <defs>
            <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0" transform="scale(0.00125)" />
            </pattern>
            <image id="image0" width="800" height="800"
              xlink:href="data:image/png;base64,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" />
          </defs>
        </svg>

      </div>
      <!-- <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
        <div class="map">
          <object style="border:0; height: 280px; width: 100%;"
            data="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d34015.943594576835!2d-106.43242624069771!3d31.677719472407432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86e75d90e99d597b%3A0x6cd3eb9a9fcd23f1!2sCourtyard+by+Marriott+Ciudad+Juarez!5e0!3m2!1sen!2sbd!4v1533791187584"></object>
        </div>
      </div> -->

    </div>

  </div>

</section>
<!-- Contact Section End -->

<!-- Footer Section Start -->
<app-footer></app-footer>
<!-- Footer Section End -->

<!-- Go to Top Link -->
<a href="#" class="back-to-top">
  <i class="lni-arrow-up"></i>
</a>

<!-- Preloader -->
<div id="preloader">
  <div class="loader" id="loader-1"></div>
</div>
